import script from "./LedsArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./LedsArea.vue?vue&type=script&setup=true&lang=ts"

import "./LedsArea.vue?vue&type=style&index=0&id=0c3f859c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c3f859c"]])

export default __exports__